/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_WateringInputs */

const vi_care_log_activity_watering = /** @type {(inputs: Care_Log_Activity_WateringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tưới nước`)
};

/**

* @param {Care_Log_Activity_WateringInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_watering = /** @type {((inputs?: Care_Log_Activity_WateringInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_WateringInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_watering(inputs)
});